import { createContext, useContext } from "react";

import type { IconColor } from "../../atoms/icons";
import type { ListItemContextValue } from "./types";

/**
 * Tells the slots whether the row is one pressable element (so `LeadingAvatar`
 * can hide itself from native screen readers inside one), its tone and
 * whether it's disabled (for their colours).
 */
export const ListItemContext = createContext<ListItemContextValue | null>(null);

export const useListItemContext = (): ListItemContextValue => useContext(ListItemContext) ?? {};

/** An icon slot's colour: disabled, then the caller's, then the tone's, then Figma's */
export const listItemIconColor = (
  { tone, disabled }: ListItemContextValue,
  color: IconColor | undefined,
): IconColor =>
  disabled
    ? "neutral-foreground-attenuated"
    : (color ??
      (tone === "destructive" ? "button-destructive-default" : "neutral-foreground-intermediate"));
